module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "commingsoon"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    ref: "moviesUl",
    staticClass: "section-content"
  }, [_c('ul', {
    staticClass: "items"
  }, _vm._l((_vm.movies), function(movie, movieindex) {
    return _c('li', {
      staticClass: "item"
    }, [_c('router-link', {
      attrs: {
        "to": '/movie/subject/' + movie.id
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      }
    }, [_c('div', {
      staticClass: "item-img"
    }, [_c('img', {
      staticStyle: {
        "width": "100px",
        "height": "148px"
      },
      attrs: {
        "src": movie.images.medium,
        "alt": ""
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(movie.title))]), _vm._v(" "), _c('div', {
      staticClass: "rating"
    }, [_c('span', {
      staticClass: "rating-stars"
    }, _vm._l((_vm.starClasses[movieindex]), function(starClass) {
      return _c('span', {
        staticClass: "rating-star",
        class: starClass
      })
    })), _vm._v(" "), _c('span', {
      staticClass: "rating-average"
    }, [_vm._v(_vm._s(movie.rating.average))])])])])], 1)
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h2', [_vm._v("即将上映")]), _vm._v(" "), _c('a', {
    staticClass: "more",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("更多")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b1a744c4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/movie/movieItem.vue
// module id = 62
// module chunks = 1